import React from "react";

function BreachActionComplete(props: any) {
    return (
        <>
            <div className="dialog-header" style={{ display: "flex", marginBottom: "unset" }}>
                <div
                    className="dialog-icon status-default"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "unset",
                        backgroundColor: "rgba(116, 170, 80, 0.16)",
                    }}
                >
                    <em className="las la-check-circle breach-action-dialog-icon"></em>
                </div>
                <div className="box-title-text">
                    <h2 className="box-title breach-dialog-title" style={{ color: "#56803C" }}>
                        Action Complete
                    </h2>
                </div>
            </div>

            <div className="dialog-body" style={{ margin: "0px 3.5rem" }}>
                <div className="row">
                    <div className="margin-left-xs">
                        <p>Great job! Taking action helps keep your identity safe.</p>
                    </div>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row" style={{ justifyContent: "flex-end" }}>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default breach-btn-color btn-breach-primary btn-primary"
                            onClick={props.closeDialog}
                            style={{ width: "7.9375rem" }}
                        >
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BreachActionComplete;
